import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AddButton from "../../../components/AddButton";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../../constants/Constants";
import userContext from "../../../context/users/UserContext";
import {
  changeUserStatus,
  getFirmTechnicianList,
  fetchEditUserData,
  changeUserLockStatus,
} from "../../../service/UserService";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import DataTable from "../../../components/DataTable/DataTable";
import NotAuthorized from "../../../components/NotAuthorized";
import { FirmTechnicianColumns } from "../../../constants/Columns/FirmTechnician";
import PageHeader from "../../../components/PageHeader";
import ListView from "../../../components/ListView/ListView";
import ListViewV2 from "../../../components/ListViewV2/ListViewV2";
import { SupervisorColumns } from "../../../constants/Columns/Supervisor";
import { PrimaryButton } from "@fluentui/react";
import loaderContext from "../../../context/loader/LoaderContext";
import { FilterPopUpComponent } from "../../Supervisor/SupervisorList";
import ListViewV3 from "../../../components/ListViewV3/ListViewV3";
import PasswordResetModal from "../../../components/PasswordResetModal/PasswordResetModal";
const queryClient = new QueryClient();

const FirmTechnicianList = (props) => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchParams] = useSearchParams();
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [selectedUsername, setSelectedUsername] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [fullName,setFullName]=useState("");

  const { setLoaderRunning, ref } = useContext(loaderContext);

  const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);

  const [firmsListForFilter, setFirmListForFilters] = useState([]);
  const [storeFirmsListForFilter, setStoreFirmsListForFilters] = useState([]);
  const [firmList, setFirmList] = useState([]);
  const [storeFirmList, setStoredFirmList] = useState([]);
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);
  const [dataQueryState, setDataQueryState] = useState({});

  let firmID =
    props.firmId === undefined
      ? searchParams.get("firmId") != null
        ? searchParams.get("firmId")
        : firmId
      : props.firmId;

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }
  const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);
  }; 
  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    console.log("--- FetchData ---", options);
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      firmId: firmID,
      firmAccessList: Object.values(displayListAppliedFilter).map(item => item.value),
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    const response = await getFirmTechnicianList(body);
    console.log("--- Response ---", response);
    let data = null;
    let pageCount = null;
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      setFirmList(response.data.data.firmList);
      setStoredFirmList(response.data.data.firmList);
      data = response.data.data.userList;
      pageCount = response.data.data.totalPages;

      return {
        rows: data,
        pageCount: pageCount,
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      return {
        rows: data,
        pageCount: pageCount,
      };
    }
  };

  function handleCaching(data) {
    setUpdateCurrentPage(!updateCurrentPage);
    setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
  }

  const handleActionButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleLockButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserLockStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  function ReloadData(id, actionOrLocked) {
    // setUpdateCurrentPage(() => !updateCurrentPage);
    // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
     let newIndex = -1;
     let newData = dataQueryState?.data?.rows.filter((row, index) => {
       if (row.id == id) {
         newIndex = index;
         return true;
       }
       return false;
     });  
     setDataQueryState(() => {
       const newValue = {
         ...dataQueryState
       };
       if(newValue.data.rows[newIndex] != null){
          if(actionOrLocked){
            newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active;
          }else if(!actionOrLocked){
            newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
          }
       }
       return newValue;
     });
 
   }

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (props.firmId === undefined) {
      navigate(
        AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id,
        {}
      );
    } else {
      if(roles[0] === USERTYPES.ADMIN) {
        navigate(
          AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id + "&for=firm",
          {}
        );
      } else {
        navigate(
          AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id + "&for=client",
          {}
        );
      }
    }
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const columns = SupervisorColumns(
    userId,
    handleActionButton,
    handleUserClick,
    handleLockButton,
    openPasswordReset
  );

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <Link
          key="1"
          to={
            props.firmId === undefined
              ? AuthRoutes.MYADDFIRMTECHNICIAN + "?firmId="+firmId
              : roles[0] === USERTYPES.ADMIN
              ? AuthRoutes.MYADDFIRMTECHNICIAN +
                "?firmId=" +
                firmID +
                "&for=firm"
              : AuthRoutes.MYADDFIRMTECHNICIAN +
                "?firmId=" +
                firmID +
                "&for=client"
          }
        >
          <div className="add-button-list-view">
            {/* <AddButton text={t("firmtechnician.add-firmtechnician")} /> */}
            <PrimaryButton
              text={t("firmtechnician.add-firmtechnician")}
              className={
                "common-default-active-button list-view-top-buttons-styles"
              }
            />
          </div>
        </Link>
      ),
    },
  ];

  const options = [
    { key: "username", text: t("user.username") },
    { key: "firstName", text: t("user.first-name") },
    { key: "lastName", text: t("user.last-name") },
    { key: "email", text: t("user.email") },
    { key: "mobile", text: t("user.mobile") },
    { key: "active", text: t("user.action") },
  ];

  const handleClearFilter = () => {
    setDisplayListAppliedFilter([]);
    setFirmListForFilters([]);
    setStoreFirmsListForFilters([]);
    setPagination(()=>{
      const newItem = {...paginationObj};
      newItem.pageIndex = 0;
      return newItem;
    });


    setTimeout(()=>{
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = "";
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
      },100);
  };

 


  const removeBadgeFromFilter = (toBeRemoveObj) => {
    setFirmListForFilters((current) =>
    current.filter((item) => item.label !== toBeRemoveObj.label)
  );
  setStoreFirmsListForFilters((current) =>
    current.filter((item) => item.label !== toBeRemoveObj.label)
  );

  setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

  setPagination(()=>{
    const newItem = {...paginationObj};
    newItem.pageIndex = 0;
    return newItem;
  });

  setTimeout(()=>{
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
    },100);
  };

  

  const handleApplyClick = (filterValue) => {
    if(filterValue != undefined)filterValue = filterValue.trim();
    setDisplayListAppliedFilter(firmsListForFilter);

    setPagination(()=>{
      const newItem = {...paginationObj};
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(()=>{
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterInput = filterValue;
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
    },100);
  };

  return (
    <>
    <PasswordResetModal
        username={selectedUsername}
        visible={showResetModal}
        onClose={() => setShowResetModal(false)}
        fullName={fullName}
      />
      {(roles[0] === USERTYPES.FIRMTECHNICIAN ||
        roles[0] === USERTYPES.FIRMDOCTOR ||
        roles[0] === USERTYPES.FIRMADMIN ||
        roles[0] === USERTYPES.ADMIN) && (
        <ListViewV3
          buttonsTopBar={buttonsTopBar}
          sortDropdownOptions={options}
          fetchData={fetchData}
          columns={columns}
          handleUserClick={handleUserClick}
          filterObj={filterObj}
          setFilterObj={setFilterObj}
          sortObj={sortObj}
          setSortObj={setSortObj}
          setPagination={setPagination}
          paginationObj={paginationObj}
          uniqueKey={"Technician"}
          heading={t("navbar.firm-technicians")}
          handleApplyClick={handleApplyClick}
          displayListAppliedFilter={displayListAppliedFilter}
          handleClearFilter={handleClearFilter}
          removeBadgeFromFilter={removeBadgeFromFilter}
          placeholder={"Username"}
          showFilter={true}
          enhancedFilter={true}
          showSort={true}
          filterPopUpComponent={
            <FilterPopUpComponent
              setFirmList = {setFirmList}
              firmList = {firmList}
              storeFirmList={storeFirmList}
              firmsListForFilter={firmsListForFilter}
              setFirmListForFilters={setFirmListForFilters}
            />
          }
          fullLength={props.fullLength}
          fullLengthForRow={props.fullLengthForRow}
          setDataQueryState={setDataQueryState}
          dataQueryState={dataQueryState}
        />
        // <ListView
        //   pageHeader="firmtechnician.firmtechnician"
        //   buttonsTopBar={buttonsTopBar}
        //   sortDropdownOptions={options}
        //   fetchDataFunction={fetchFirmTechnicianList}
        //   columns={columns}
        //   handleUserClick={handleUserClick}
        //   widthContainer="40%"
        //   updateCurrentPage={updateCurrentPage}
        //   filterObj={filterObj}
        //   heightTBody="67vh"
        // />
      )}
      {roles.length != 0 && roles[0] === USERTYPES.RADIOLOGIST && (
        <NotAuthorized />
      )}
    </>
  );
};

export default FirmTechnicianList;
